"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
class Footer extends React.Component {
    render() {
        const { menu } = this.props;
        const footerMenu = menu.filter(item => item.place === 'footer');
        return (React.createElement("footer", { className: "Footer" },
            React.createElement("div", { className: "footer-element" }),
            React.createElement("div", { className: "container" },
                React.createElement("nav", { className: "row is-spaced no-wrap-desktop" },
                    React.createElement("div", { className: "column is-lg-3 is-vertical-mobile" },
                        React.createElement("a", { className: "logo", href: "/" },
                            React.createElement("img", { src: this.props.logo, alt: "" }))),
                    this.props.footer.map((column, index) => (React.createElement("div", { key: index, className: "column is-xs-12 is-md-6 is-lg-auto" }, column.items.map((item, i) => this.renderItem(item, i))))))),
            React.createElement("div", { className: "bottom-section" },
                React.createElement("div", { className: "container" },
                    React.createElement("div", { className: "level is-space-between" },
                        React.createElement("div", { className: "group is-vertical-mobile" }, footerMenu.map((item, index) => (React.createElement("a", { href: item.path, className: `${this.isActive(item.path) ? 'active' : ''}`, key: index }, item.label)))),
                        React.createElement("div", { className: "is-hidden-mobile" },
                            React.createElement("a", { href: "https://dx.no", className: "" }, "Utviklet av DX")))))));
    }
    renderItem(item, index) {
        switch (item.type) {
            case 'title':
                return this.renderTitle(item.value, index);
            case 'text':
                return this.renderText(item.value, index);
            case 'link':
                return this.renderLink(item.value, item.href, index);
            case 'html':
                return this.renderHtml(item.value, index);
        }
    }
    renderTitle(value, index) {
        return (React.createElement("h2", { dangerouslySetInnerHTML: { __html: value }, key: index, className: "" }));
    }
    renderText(value, index) {
        return (React.createElement("p", { dangerouslySetInnerHTML: { __html: value }, key: index, className: "" }));
    }
    renderLink(value, href, index) {
        return (React.createElement("a", { dangerouslySetInnerHTML: { __html: value }, key: index, href: href, className: "" }));
    }
    renderHtml(value, index) {
        return (React.createElement("div", { dangerouslySetInnerHTML: { __html: value }, key: index }));
    }
    isActive(menuPath) {
        if (typeof window === 'undefined') {
            return false;
        }
        return window.location.pathname.replace(/\/$/, '') === menuPath.replace(/\/$/, '');
    }
}
exports.Footer = Footer;



// WEBPACK FOOTER //
// ./src/layouts/components/Footer.tsx